const initState = {
    getById:{
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    }
};

export default initState;